export default "__VITE_ASSET__CNeoNrKV__"